import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {BreakpointerConfig, Breakpointer} from "./breakpointer"

export const breakpointerLoader = function (options = {}) {
    componentLoader(componentConfig(Breakpointer, BreakpointerConfig.componentTypeKey, BreakpointerConfig.baseHtmlClass), options);
};

